

module.exports = __webpack_require__.stylable.create(
    "o2",
    {"classes":{"root":"s321","sideNav":"s322"},"vars":{"base-font-family":"--o0-base-font-family","color-theme-link":"--o0-color-theme-link","color-primary-dark":"--o0-color-primary-dark"},"stVars":{},"keyframes":{}},
    "",
    4,
    13,
    null
);
